 <template>
     <div>
        <vs-row>
            <vs-col sm="12" lg="6">
                <h4 class="p-2">Plan de estudios </h4>
            </vs-col>
            <vs-col sm="12" lg="6">
                <vs-button
                    success
                    class="ml-auto"
                    :disabled="!programa"
                    @click="activeCrearPlan =! activeCrearPlan"
                >
                    <i class="fas fa-plus mr-2"></i>Crear plan de estudios
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Programa
                    </label>
                    <vs-select filter :loading="loadingPrograma" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar programa" :key="programaId" v-model="programa" :disabled="!programas.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('programa')">
                            Requerido
                        </template>
                        <template v-if="programas.length" autocomplete="off">
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Plan
                    </label>
                    <vs-select filter :loading="loadingPlan" class="aqui pt-0" id="plan" placeholder="Seleccionar plan" :key="planId" v-model="plan" :disabled="!planes.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('plan')">
                            Requerido
                        </template>
                        <template v-if="planes.length" autocomplete="off">
                            <vs-option v-for="option in planes" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getPlanesEstudios()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-button
            v-if="planesEstudio.nombre"
            class="ml-auto mb-3"
            flat
            @click="activeEditarPlan =! activeEditarPlan"
        >
            <i class="fas fa-edit mr-2"></i> Editar plan
        </vs-button>
        <tabla-planes v-if="planesEstudio.nombre" :planesEstudio="planesEstudio" :plan="plan" :programa="programa" @refreshTable="getPlanesEstudios"></tabla-planes>
        <h5 class="text-center mt-5" v-else>Sin información</h5>
        <crear-plan v-model="activeCrearPlan" :programaSelect="programa" :programas="programas" @refreshTable="getNewPlan"></crear-plan>
        <editar-plan v-model="activeEditarPlan" :planesEstudio="planesEstudio" :programas="programas" @refreshTable="refreshEditar"></editar-plan>
     </div>
</template>

 <script>
import academico from '../../../../api/requests/academico'
import TablaPlanes from './tabla-plan-estudio.vue'
import CrearPlan from './modal/crear_plan.vue'
import EditarPlan from './modal/editar_plan.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            programa:'',
            programas: [],
            programaId: (new Date()).getTime(),
            loadingPrograma: false,
            plan:'',
            planes: [],
            planId: (new Date()).getTime(),
            loadingPlan: false,
            errorFields: [],
            planesEstudio: [],
            activeCrearPlan: false,
            activeEditarPlan: false
        }
    },
    components:{
        TablaPlanes,
        CrearPlan,
        EditarPlan
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await academico.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getPrograma(){
            try {
                this.loadingPrograma = true
                const response = await academico.getPrograma(this.institucion)
                this.loadingPrograma = false
                this.programas = response.data
                this.programaId = (new Date()).getTime()
            }
            catch{

            }
        },
        async getNewPlan(idPrograma, idPlan){
            try {
                this.programa = idPrograma
                this.loadingPlan = true
                const response = await academico.getPlanEstudios(this.programa)
                this.loadingPlan = false
                this.planes = response.data
                this.planId = (new Date()).getTime()
                this.plan = idPlan
            }
            catch{
            }

        },
        async getPlan(){
            try {
                this.loadingPlan = true
                const response = await academico.getPlanEstudios(this.programa)
                this.loadingPlan = false
                this.planes = response.data
                this.planId = (new Date()).getTime()
            }
            catch{

            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.programa) {
                this.errorFields.push('programa')
            }
            if (!this.plan) {
                this.errorFields.push('plan')
            }
            if (!this.errorFields.length){

                return true
            } else {
                return null
            }
        },
        async getPlanesEstudios(){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await academico.getPlanesEstudios(this.plan)
                    if(response.error == false){
                        this.planesEstudio = response.plan
                    }
                    loading.close()
                }
                catch(error){
                    loading.close()
                }
            }
        },
        refreshEditar(programa){
            this.programa = programa
            this.getPlan()
            this.getPlanesEstudios()
        }
    },
    watch:{
        institucion(){
            this.programa = ''
            this.plan = ''
            this.planesEstudio = []
            this.getPrograma()
        },
        programa(){
            this.plan = ''
            this.planesEstudio = []
            this.getPlan()
        },
        plan(){
            if(this.plan != ''){
                this.getPlanesEstudios()
            }
        }
    }
}
</script>